import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getClientConfigurations } from "../redux/slice/RegisterAppSlice";

const HEARTBEAT_KEY = "browserHeartbeat";
const STORAGE_KEY = "payerCode";
const HEARTBEAT_INTERVAL = 2000; // ms
const STALE_TIMEOUT = 3000; // ms

const usePersistentPayerCode = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const updateHeartbeat = () => {
      localStorage.setItem(HEARTBEAT_KEY, Date.now().toString());
    };
    const lastHeartbeat = parseInt(localStorage.getItem(HEARTBEAT_KEY) || "0", 10);
    const now = Date.now();
    if (now - lastHeartbeat > STALE_TIMEOUT) {
      localStorage.removeItem(STORAGE_KEY);
    }
    updateHeartbeat();

    const heartbeat = setInterval(updateHeartbeat, HEARTBEAT_INTERVAL);
    const urlParams = new URLSearchParams(window.location.search);
    const payerCode = urlParams.get("payerCode");
    if (payerCode) {
      localStorage.setItem(STORAGE_KEY, payerCode);
    }
    dispatch(getClientConfigurations());
    return () => {
      clearInterval(heartbeat);
    };
  }, [dispatch]);
};

export default usePersistentPayerCode;
